"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _SecurityContextHolder = require("../../api/SecurityContextHolder");
var _MenuItemTypeCode = _interopRequireDefault(require("./MenuItemTypeCode"));
var _SamlLink = _interopRequireDefault(require("../../components/authn/SamlLink"));
var _Menu = _interopRequireDefault(require("../../api/Menu"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const renderDropdown = menuItem => {
  const titles = [];
  const subMenus = [];
  const items = [];
  if (menuItem.children) {
    menuItem.children.filter(child => typeof child.visible !== 'undefined' && child.visible).forEach(child => {
      if (typeof child.children !== 'undefined' && child.children.length > 0) {
        titles.push(child.title || child.name);
        subMenus.push(child);
      } else {
        items.push(child);
      }
    });
  } else {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
  }
  let columns = 1;
  let itemsPerColumn = 0;
  let extraColumns = 0;
  if (subMenus.length > 0) {
    columns = subMenus.length;
    if (items.length > 0) {
      columns++;
    }
  } else if (items.length < 5) {
    columns = items.length;
    itemsPerColumn = 1;
  } else {
    columns = 5;
    itemsPerColumn = Math.floor(items.length / columns);
    extraColumns = items.length - columns * itemsPerColumn;
  }
  const isItemsOnly = subMenus.length === 0;
  const columnData = new Array(columns);
  const columnContent = new Array(columns);
  let i = 0;
  let start = 0;
  for (i = 0; i < columnData.length; i++) {
    if (isItemsOnly) {
      let itemsThisColumn = itemsPerColumn;
      if (extraColumns > 0) {
        itemsThisColumn++;
        extraColumns--;
      }
      const columnItems = new Array(itemsThisColumn);
      let x = 0;
      for (x = 0; x < columnItems.length; x++) {
        columnItems[x] = items[start + x];
      }
      start += columnItems.length;
      columnData[i] = columnItems;
    } else if (subMenus.length > i) {
      columnData[i] = subMenus[i].children;
    } else {
      columnData[i] = items;
    }
    let title = /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
    if (i < titles.length) {
      title = titles[i];
      if (title.trim().length > 0) {
        title = /*#__PURE__*/_react.default.createElement("h1", {
          className: "title submenu-title"
        }, title);
      } else {
        title = /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
      }
    }
    columnContent[i] = /*#__PURE__*/_react.default.createElement("div", {
      className: "column",
      key: `columnContent_key_${i}`
    }, title, /*#__PURE__*/_react.default.createElement("ul", {
      className: "menu-list"
    }, columnData[i].map(child => /*#__PURE__*/_react.default.createElement("li", {
      key: `mli_${child.id}`
    }, child.menuItemTypeCode === _MenuItemTypeCode.default.SAML_PROVIDER ? /*#__PURE__*/_react.default.createElement("li", {
      key: `mli_${menuItem.id}`
    }, /*#__PURE__*/_react.default.createElement(_SamlLink.default, {
      title: child.title || child.name,
      providerId: child.icon,
      path: child.path
    })) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
      to: child.path.includes('http') ? {
        pathname: `${child.path}`
      } : child.path,
      activeClassName: "is-active",
      className: "title",
      key: `mlc_${child.id}`
    }, child.title || child.name), (child.pageTitle || child.description) && /*#__PURE__*/_react.default.createElement("p", {
      className: "desc"
    }, child.pageTitle || child.description), (child.altTitle || child.tutorialUrl) && /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
      to: child.path.includes('http') ? {
        pathname: `${child.path}`
      } : child.path,
      activeClassName: "",
      className: "alt-title",
      key: `mlc_alt_${child.id}`
    }, child.tutorialUrl || child.altTitle))))));
  }
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, columnContent && columnContent.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "navbar-dropdown"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container is-fluid"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "columns"
  }, columnContent.map(column => column)))));
};
const SimpleMenuLinks = _ref => {
  let {
    menuItems,
    toggleActive
  } = _ref;
  let menuItemList = [];
  if (_SecurityContextHolder.SecurityContextHolder.isAuthenticated() && _SecurityContextHolder.SecurityContextHolder.getCurrentContext().menu) {
    menuItemList = _SecurityContextHolder.SecurityContextHolder.getCurrentContext().getMainMenuLinks();
  }
  if (menuItems && (!_SecurityContextHolder.SecurityContextHolder.isAuthenticated() || !_SecurityContextHolder.SecurityContextHolder.getCurrentContext()?.menu)) {
    const menu = _Menu.default.from({
      menuItems
    });
    menuItemList = menu.getMainMenuLinks();
  } else if (menuItems && menuItems.length > 0) {
    menuItemList = menuItems;
  }
  return menuItemList.filter(menuItem => typeof menuItem.visible !== 'undefined' && menuItem.visible).map(menuItem => /*#__PURE__*/_react.default.createElement("div", {
    className: "navbar-item has-dropdown is-hoverable is-full-width",
    "aria-haspopup": "true",
    key: `mml_${menuItem.id}`,
    onMouseEnter: () => window.innerWidth >= 1024 ? toggleActive(true) : ''
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
    to: menuItem.path,
    activeClassName: "is-active",
    className: "navbar-link flex",
    key: `ml_${menuItem.id}`
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons"
  }, menuItem.icon), menuItem.title || menuItem.name), /*#__PURE__*/_react.default.createElement("div", {
    className: "marker-class"
  }), renderDropdown(menuItem)));
};
SimpleMenuLinks.propTypes = {
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    children: _propTypes.default.array,
    description: _propTypes.default.string,
    icon: _propTypes.default.string,
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    image: _propTypes.default.string,
    imageAlt: _propTypes.default.string,
    path: _propTypes.default.string,
    title: _propTypes.default.string,
    visible: _propTypes.default.bool
  }))
};
SimpleMenuLinks.defaultProps = {
  menuItems: []
};
var _default = exports.default = SimpleMenuLinks;
//# sourceMappingURL=SimpleMenuLinks.js.map